import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { adminLogin, setToken, adminMe } from "@/lib/adminApi";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    document.title = "Admin · Wolfkeeper Auction";
    adminMe().then(() => nav("/admin")).catch(() => {});
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { token } = await adminLogin(email, password);
      setToken(token);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-ink text-bone grid place-items-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-ink-2 border border-hair rounded-3xl p-8 md:p-10">
        <div className="wolf-mark gold-foil text-3xl mb-6">TS</div>
        <div className="text-eyebrow text-gold">Admin · Wolfkeeper Auction</div>
        <h1 className="font-display text-4xl mt-2">Sign in.</h1>
        <p className="text-bone/60 text-sm mt-3">Restricted to authorized team members only.</p>

        <div className="mt-8 space-y-5">
          <div className="field">
            <label>Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email"/>
          </div>
          <div className="field">
            <label>Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password"/>
          </div>
        </div>
        <button type="submit" disabled={loading} className="btn-gold mt-8 w-full justify-center" data-testid="admin-login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
